import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import Header from './Header';
import Sidebar from './Sidebar';

// API Base URL - usado em toda a aplicação
export const API_BASE_URL = 'https://api.cerdata.co';

const MainLayout: React.FC = () => {
  const [apiEnv, setApiEnv] = useState('');
  const auth = useAuth();

  // Extract the username from the OIDC user profile
  const username = auth.user?.profile.name || auth.user?.profile.email || "Admin User";
  
  useEffect(() => {
    // Show API environment info in development mode
    if (process.env.NODE_ENV === 'development') {
      setApiEnv(`API: ${API_BASE_URL}`);
    }
  }, []);

  return (
    <div className="flex h-screen bg-gray-100">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header username={username} />
        
        {apiEnv && (
          <div className="bg-blue-900 text-white px-4 py-1 text-xs text-center">
            {apiEnv} - Development Mode
          </div>
        )}
        
        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-4 transition-all duration-300">
          <div className="w-full max-w-full">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};

export default MainLayout;